import { useGLTF } from "@react-three/drei";
import { isMobile } from "react-device-detect";
import React, { useRef, useState } from "react";
import { PointLight } from "three";
import { useFrame } from "@react-three/fiber";
import { stageObject } from "../interface";

export const Coin = ({ url, scale, position, getCharacters }: stageObject) => {
  const { scene } = useGLTF(url);
  const coinRef = useRef<any>();
  const lightRef = useRef<PointLight>(null!);
  const [hovered, setHovered] = useState(false);

  const speed = 0.001; // 初始旋转速度
  const rotation = 0.005;

  const xLimit = isMobile ? [-1, 1] : [-3.5, -1.5];
  const yLimit = isMobile ? [0, 2] : [0.8, 2];

  let directionX = true;
  let directionY = true;
  let rotationY = true;

  useFrame(() => {
    if (coinRef.current && lightRef.current) {
      //rocketRef.current.rotation.x += 0.01;
      //rocketRef.current.rotation.z += 0.01;
      if (
        coinRef.current.position.x < xLimit[0] ||
        coinRef.current.position.x > xLimit[1]
      ) {
        directionX = !directionX;
        rotationY = Math.random() < 0.5;
      }

      if (
        coinRef.current.position.y < yLimit[0] ||
        coinRef.current.position.y > yLimit[1]
      ) {
        directionY = !directionY;
        rotationY = Math.random() < 0.5;
      }
      if (!hovered) {
        if (directionX) {
          coinRef.current.position.x -= speed;
        } else {
          coinRef.current.position.x += speed;
        }

        if (directionY) {
          coinRef.current.position.y -= speed;
        } else {
          coinRef.current.position.y += speed;
        }

        // 缓慢旋转火箭
        if (rotationY) {
          coinRef.current.rotation.y += rotation;
        } else {
          coinRef.current.rotation.y -= rotation;
        }
      }

      lightRef.current.position.set(
        coinRef.current.position.x,
        coinRef.current.position.y - 0.2,
        coinRef.current.position.z + 0.2,
      );
    }
  });

  return (
    <>
      <primitive
        ref={coinRef}
        object={scene}
        position={position?.toArray()}
        scale={scale}
        onClick={() => getCharacters("coin")}
        onPointerOver={() => {
          setHovered(true);
        }}
        onPointerOut={() => {
          setHovered(false);
        }}
      />
      <pointLight
        ref={lightRef}
        intensity={hovered || isMobile ? 1 : 0}
        color={"#ffcc00"}
      />
    </>
  );
};
